import { useNavigate, useParams } from 'react-router-dom';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { SettingCard } from '../setting-card';
import { useDeleteRoomMutation } from '../../manage-room.slice';
import { StyledCardHeaderContainer, StyledDescriptionText, StyledHeaderTitle, StyledIcon } from './delete-tab.styles';
import { DeleteRoomConfirmModal } from './components/delete-room-confirm-modal';
export const DeleteTab = () => {
  const {
    roomCode
  } = useParams();
  const navigate = useNavigate();
  const [deleteRoom, {
    isLoading
  }] = useDeleteRoomMutation();
  const handleDeleteRoom = async () => {
    try {
      await deleteRoom({
        roomCode: (roomCode as string)
      }).unwrap();
      navigate(`/rooms?tab=manage-rooms`, {
        replace: true
      });
    } catch (error) {
      if (isQueryErrorWithMessage(error) && error.status === 400) {
        NotificationDispatch('error', error.data.message);
      }
      NotificationDispatch('error', 'Uh-oh. There was an error while deleting your room. Please try again.');
    }
  };
  return <SettingCard showDefaultHeading={false} data-sentry-element="SettingCard" data-sentry-component="DeleteTab" data-sentry-source-file="delete-tab.tsx">
      <StyledCardHeaderContainer data-sentry-element="StyledCardHeaderContainer" data-sentry-source-file="delete-tab.tsx">
        <StyledIcon data-testid="setting-card-icon" icon={faExclamationCircle} data-sentry-element="StyledIcon" data-sentry-source-file="delete-tab.tsx" />
        <StyledHeaderTitle data-sentry-element="StyledHeaderTitle" data-sentry-source-file="delete-tab.tsx">Delete</StyledHeaderTitle>
      </StyledCardHeaderContainer>

      <StyledDescriptionText data-sentry-element="StyledDescriptionText" data-sentry-source-file="delete-tab.tsx">If the room is deleted, you will not be able to recover it.</StyledDescriptionText>

      <DeleteRoomConfirmModal
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    handleDeleteRoom={handleDeleteRoom} isLoading={isLoading} data-sentry-element="DeleteRoomConfirmModal" data-sentry-source-file="delete-tab.tsx" />
    </SettingCard>;
};